<template>
    <div v-if="companies.length" class="form__subsection">
        <h3>Bedrift{{ companies.length > 1 ? 'er' : '' }}:</h3>
        <ul class="mypage-profile__action-list">
            <li v-for="company in companies" :key="company.id" class="mypage-profile__action-row">
                <span class="mypage-profile__member-name">
                    <span class="mypage-profile__member-icon">
                        <i class="pi pi-building" aria-hidden="true"></i>
                    </span>
                    <CompanyModal :company="company" :csrf-token="csrfToken" @left="onLeft" />
                </span>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import CompanyModal from './CompanyModal.vue';

const props = defineProps({
    csrfToken: { type: String, required: true },
});

const companies = ref([]);

onMounted(async () => {
    try {
        const response = await fetch('/xhr/frontend/companies', {
            headers: { 'Accept': 'application/json' },
        });
        if (!response.ok) {
            return;
        }
        const data = await response.json();
        companies.value = data.companies || [];
    } catch (e) {
        // Leave the list empty.
    }
});

function onLeft(companyId) {
    companies.value = companies.value.filter((c) => c.id !== companyId);
}
</script>
